import { BaseDto } from '@/shared/dtos/base-dto';

export class datos_adicionales_producto extends BaseDto {
    public texto !: string;
    public id_prodcuto !: number;
    public tipo_registro !: number;
} 
